import { DealUserAccess } from './user.types';

export const dealUserAccessRecordsMock: DealUserAccess[] = [
    {
        id: 1,
        parent_id: 371,
        parent_type: 'deal',
        child_id: 401,
        child_type: 'user',
        role_id: 2
    },
    {
        id: 2,
        parent_id: 372,
        parent_type: 'deal',
        child_id: 402,
        child_type: 'user',
        role_id: 1
    },
    {
        id: 3,
        parent_id: 373,
        parent_type: 'deal',
        child_id: 403,
        child_type: 'user',
        role_id: 3
    },
    {
        id: 4,
        parent_id: 374,
        parent_type: 'deal',
        child_id: 404,
        child_type: 'user',
        role_id: 1
    },
    {
        id: 5,
        parent_id: 375,
        parent_type: 'deal',
        child_id: 405,
        child_type: 'user',
        role_id: 3
    },
    {
        id: 6,
        parent_id: 376,
        parent_type: 'deal',
        child_id: 406,
        child_type: 'user',
        role_id: 2
    },
    {
        id: 7,
        parent_id: 377,
        parent_type: 'deal',
        child_id: 407,
        child_type: 'user',
        role_id: 1
    },
];
